import { SxProps } from "@mui/material";

export const sxModal: SxProps = {
    display: 'flex',
    position: 'absolute',
    top: '50%',
    right: '0',
    transform: 'translateY(-50%)',
    maxWidth: '585px',
    bgcolor: '#fff',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px 48px',
    gap: '20px',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
    '@media(max-width: 690px)': {
        maxWidth: '90%',
        padding: '16px 24px',
    }
}

export const sxCloseIconButton: SxProps = {
    position: 'absolute',
    right: '16px',
    top: '16px',
    color: '#383838',
    '@media(max-width: 650px)': {
        right: '16px',
        top: '12px'
    }
}

export const sxSemibold: SxProps = {
    fontFamily: 'Unimed-Sans',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '24px'
}

export const sxRegular: SxProps = {
    fontFamily: 'Unimed-Sans',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#717171'
}

export const sxTimelineDot: SxProps = {
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0'
}

export const sxMicroTimelineDot: SxProps = {
    backgroundColor: '#4C4C4C', margin: '0'
}

export const sxTimelineConnector: SxProps = {
    width: '2px'
}

export const sxTodayMarkerContent: SxProps = {
    padding: '4px 0px',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center'
}